import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/tentang")({
  beforeLoad: () => {
    throw redirect({ to: "/en/about" } as any as any);
  },
  component: () => null,
});
